// Tree row IDs are reassigned when selected segments move between the two trees.
// Match expanded rows by their full path before applying the new row IDs.
export const preserveTreeExpansion = (previousTree, nextTree, expandedIds) => {
    const expanded = new Set(expandedIds);
    const expandedPaths = new Set();
    const visit = (items, parentPath, callback) => {
        items.forEach(item => {
            const path = [...parentPath, item.mergeKey ?? item.value ?? item.text];
            callback(item, JSON.stringify(path));
            if (item.items) visit(item.items, path, callback);
        });
    };
    visit(previousTree, [], (item, path) => {
        if (expanded.has(item.treeId)) expandedPaths.add(path);
    });
    const nextExpanded = [];
    visit(nextTree, [], (item, path) => {
        if (expandedPaths.has(path)) nextExpanded.push(item.treeId);
    });
    return nextExpanded;
};
